module.exports = __webpack_public_path__ + "9b2b5a8d0bd85de342fc79535b34c02e.png";